import layoutStyles from "../styles/Layout.module.css";

const Logo = () => {
  return <h1 className={layoutStyles.logo}>The Runaways</h1>;
};
export default Logo;
